import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@patternfly/react-core';
import ExternalLinkIcon from '@patternfly/react-icons/dist/esm/icons/external-link-alt-icon';
import { SKILLS_ASSESSMENT_URL } from 'config/constants';
import { storesContext } from 'stores';

import '../styles.scss';

const FreeSkillsAssessment = () => {
  const { t } = useTranslation();
  const { userStore } = useContext(storesContext);
  const skillsAssessmentUrl =
    userStore.enablementsConfigurations?.skills_assessment_url ||
    SKILLS_ASSESSMENT_URL;

  return (
    <React.Fragment>
      <div className="no-enrollment">
        <div className="no-enrollment__assessment">
          <h3>
            {t(
              'Take a free skills assessment to see where you should start training',
            )}
          </h3>
          <p>
            {t(
              'Test your expertise, determine your skills gaps, and get recommendations for where to start with Red Hat training.',
            )}
          </p>
          <a href={skillsAssessmentUrl} target="_blank" rel="noreferrer">
            <Button icon={<ExternalLinkIcon />}>
              {t('Asses your skills')}
            </Button>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default observer(FreeSkillsAssessment);
